import { createReducer, on } from '@ngrx/store';
import { driverLicenseActions } from '../driver_license.actions';

export interface DlDeleteDocumentState {
    state: 'pending' | 'loading' | 'loaded' | 'error';
}

export const initialState: DlDeleteDocumentState = { state: 'pending' };

export const dlDeleteDocumentReducer = createReducer(
    initialState,
    on(driverLicenseActions.deleteDocument, (state) => ({ ...state, state: 'loading' as const })),
    on(driverLicenseActions.deleteDocumentSuccess, (state) => ({ ...state, state: 'loaded' as const })),
    on(driverLicenseActions.deleteDocumentFail, (state) => ({ ...state, state: 'error' as const })),
    on(driverLicenseActions.clearDeleteDocument, () => initialState)
);
